// removed by extract-text-webpack-plugin
module.exports = {"card":"Company__card___1hAtn","cardDetails":"Company__cardDetails___3Cy4_","cardHeader":"Company__cardHeader___kIlsh","cardText":"Company__cardText___vWKqD","detailsSection":"Company__detailsSection___w8PLI","detailsHeader":"Company__detailsHeader___x-j_B"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/CompanyDetail/components/Company.scss
// module id = 1209
// module chunks = 1